module.exports = __webpack_public_path__ + "96e3c5419cd85bc37e5dd526960f52b6.ttf";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/opensans-regular-webfont.ttf
// module id = 134
// module chunks = 0